import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminLayout from './components/AdminLayout'
import Dashboard from './pages/Dashboard'
import UsersPage from './pages/Users'
import PlansPage from './pages/Plans'
import TicketsPage from './pages/Tickets'
import Analytics from './pages/Analytics'
import SettingsPage from './pages/Settings'
import Messages from './pages/Messages'
import Login from './pages/Login'
import ProtectedAdminRoute from './components/ProtectedAdminRoute'
import { AdminAuthProvider } from './contexts/AdminAuthContext'
import { AdminDataProvider } from './contexts/AdminDataContext'

function App() {
  return (
    <AdminAuthProvider>
      <AdminDataProvider>
        <Routes>
          {/* Rotas relativas ao basename (definido no BrowserRouter) */}
          <Route path="login" element={<Login />} />
          <Route path="/" element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="plans" element={<PlansPage />} />
            <Route path="tickets" element={<TicketsPage />} />
            <Route path="messages" element={<Messages />} />
            <Route path="Messages" element={<Messages />} />
            <Route path="Mensagens" element={<Messages />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          {/* Qualquer rota desconhecida volta para raiz do admin */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AdminDataProvider>
    </AdminAuthProvider>
  )
}

export default App
